import { cn } from '@/utlis/cn'
import museWordmark from '/muse-wordmark.svg'

export function MuseLogo({ className, onClick }: { className?: string; onClick?: () => void }) {
    const classes = cn('w-full inline-block', className)
    return <img onClick={onClick} src={museWordmark} alt="Muse logo" className={classes} />
}
